import { createBrowserHistory } from 'history';

import { getEnvRequired } from '../utilities/env';

export const history = createBrowserHistory({
    basename: getEnvRequired('APP_BASENAME'),
});
